export default {
  coils: [],
  coil: {}
}